var StoriesSection = function () {
  var carouselSettings = {
    align: 'center',
    autoInit: false,
    circular: true,
    useResizeObserver: false
  }

  var carouselSelector = '#storiesCarousel'
  var flicking

  var init = function () {
    if ($(carouselSelector).length) {
      $(carouselSelector).ready(function () {
        flicking = new Flicking(carouselSelector, carouselSettings)

        flicking.on('ready', function () {
          flicking.addPlugins(new Flicking.Plugins.Pagination({
            selector: '.stories-section__carousel__pagination'
          }), new Flicking.Plugins.Arrow({
            prevElSelector: '.stories-section__carousel__arrow--prev',
            nextElSelector: '.stories-section__carousel__arrow--next'
          }))
        })

        flicking.init()
      })
    }
  }

  return {
    init: init
  }
}();

UL.register(StoriesSection);
